export default __webpack_public_path__ + "static/vera-bracklo-65973cd4298fde1e0b0fb67722685c5a.webp";